import React, { useContext, useMemo, useState } from "react";
import styled from "styled-components";

interface TableGridProps extends React.InputHTMLAttributes<HTMLDivElement> {
  columns?: string;
  rowHeight?: string;
}
export const TableGrid = styled.div<TableGridProps>`
  align-items: center;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: ${props => props.columns || "auto"};
  grid-auto-rows: ${props => props.rowHeight || "3rem"};
  width: 100%;
`;

type RowKey = string | null;
interface TableContext {
  setSelected: React.Dispatch<React.SetStateAction<RowKey>>;
  setHovered: React.Dispatch<React.SetStateAction<RowKey>>;
  selected: RowKey;
  hovered: RowKey;
}
const defaultContext: TableContext = {
  setSelected: () => undefined,
  setHovered: () => undefined,
  selected: null,
  hovered: null,
};
const TableContext = React.createContext<TableContext>(defaultContext);

export const Table = ({ children, ...divProps }: TableGridProps) => {
  const [selected, setSelected] = useState<RowKey>(null);
  const [hovered, setHovered] = useState<RowKey>(null);
  const value = useMemo(
    () => ({
      selected,
      hovered,
      setSelected,
      setHovered,
    }),
    [selected, hovered, setSelected, setHovered],
  );

  return (
    <TableContext.Provider value={value}>
      <TableGrid {...divProps}>{children}</TableGrid>
    </TableContext.Provider>
  );
};

export const useTableContext = () => useContext(TableContext);
